<tg-row>
    <tg-col>
        <div class="property-ui__grid-content property-ui__grid-content--ruled">
            <property-information-section></property-information-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="property-ui__grid-content property-ui__grid-content--ruled property-information-page__container--large-margin"
        >
            <property-features-section></property-features-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="property-ui__grid-content property-ui__grid-content--ruled property-information-page__container--large-margin"
        >
            <property-parking-section></property-parking-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="property-ui__grid-content property-ui__grid-content--ruled property-information-page__container--large-margin"
        >
            <property-rental-availability-section></property-rental-availability-section>
        </div>
    </tg-col>
    <tg-col>
        <div
            class="property-ui__grid-content property-information-page__container--large-margin"
        >
            <property-rental-details-section></property-rental-details-section>
        </div>
    </tg-col>
    <tg-col>
        <div class="property-information-page__container--no-padding-bottom">
            <property-rental-renti-section></property-rental-renti-section>
        </div>
    </tg-col>
</tg-row>
